import FinancialLayout from "../../Views/Financial/Layout";
import Invoiceschedule from "../../Views/Financial/Invoiceschedule";
import Invoices from "../../Views/Financial/Invoices";
import OpenInvoices from "../../Views/Financial/OpenInvoices";
import Budgets from "../../Views/Financial/Budgets";
import Prognosis from "../../Views/Financial/Prognosis";
import Liquidity from "../../Views/Financial/Liquidity";
import Toinvoice from "../../Views/Financial/Toinvoice";
import Stats from "../../Views/Financial/Stats";

export default [
    {
        path:'/financial',
        redirect:'/financial/invoiceschedule',
        name:'financial.index',
        component:FinancialLayout,
        children:[
            {
                path:'/financial/invoiceschedule',
                component:Invoiceschedule,
                name:'financial.invoiceschedule.index',
            },
            {
                path:'/financial/invoices',
                component:Invoices,
                name:'financial.invoices.index',
            },
            {
                path:'/financial/openinvoices',
                component:OpenInvoices,
                name:'financial.openinvoices.index',
            },
            {
                path:'/financial/budgets',
                component:Budgets,
                name:'financial.budgets.index',
            },
            {
                path:'/financial/prognosis',
                component:Prognosis,
                name:'financial.prognosis.index',
            },
            {
                path:'/financial/liquidity',
                component:Liquidity,
                name:'financial.liquidity.index',
            },
            {
                path:'/financial/toinvoice',
                component:Toinvoice,
                name:'financial.toinvoice.index',
            },
            {
                path:'/financial/stats',
                component:Stats,
                name:'financial.stats.index',
            },
        ]
    },
];
